// extracted by mini-css-extract-plugin
export var aboveInput = "_lg-0";
export var actionButton = "_lg-5";
export var actionButtonContainer = "_lg-1";
export var actionIcon = "_lg-6";
export var aiInfoContainer = "_lg-2";
export var attachmentWrapper = "_lg-7";
export var bold = "_lg-3";
export var checkIcon = "_lg-8";
export var clickingRecipientBar = "_lg-11";
export var commentThreadSwitch = "_lg-a";
export var draftImage = "_lg-b";
export var draftImageContainer = "_lg-c";
export var draftImages = "_lg-e";
export var editButton = "_lg-g";
export var editor = "_lg-f";
export var editorContainer = "_lg-y";
export var editorErrorTooltipWrapper = "_lg-9";
export var headerDivider = "_lg-h";
export var icon = "_lg-i";
export var info = "_lg-j";
export var internal = "_lg-n";
export var internalDivider = "_lg-k";
export var internalMessage = "_lg-l";
export var messageInputCard = "_lg-m";
export var messageInputForm = "_lg-o";
export var messageInputFormInternal = "_lg-p";
export var options = "_lg-q";
export var publicMessageCustomer = "_lg-s";
export var publicMessageMerchant = "_lg-r";
export var removeImageButton = "_lg-d";
export var replyButtons = "_lg-t";
export var showSignatureButton = "_lg-u";
export var spinner = "_lg-v";
export var verticalButtonDivider = "_lg-4";
export var visibilitySelector = "_lg-w";
export var warning = "_lg-x";
export var wrappingText = "_lg-z";
export var writingInternalNoteTopBorder = "_lg-10";